import React from "react";
import "./bannercu.css";
const BannerCu = () => {
  return (
    <div className="cu-container">
      <div className="text-container-cu">
        <h1 color="#FFFFFF">Contact Us</h1>
        <h4 color="#FFFFFF">
          Do you have any concerns or questions you would like to address? Our
          client care team is happy to help you.
        </h4>
      </div>

      <div className="back-banner"></div>
    </div>
  );
};

export default BannerCu;
